<app-kpi-widget
	[title]="'fuelDashboard.widgets.totalDecrease' | transloco"
	[icon]="icon"
	[isLoading]="isLoading"
	[totalValue]="value"
	[percentageDifference]="percentageDifference"
	[costDifference]="difference"
	[valueFormatter]="formatValue.bind(this)"
	[costFormatter]="formatCost.bind(this)"
	[costDifferenceFormatter]="formatCostDifference.bind(this)"
	[widgetDisabled]="widgetDisabled"
	[hasError]="hasError"
	[errorMessage]="errorMessage"
	[totalCost]="totalCost"
	[isUptrendPositive]="isUptrendPositive"
	[dropdownOptions]="dropdownOptions"
	[selectedDropdownValue]="selectedUnit"
	(dropdownChanged)="onDropdownChanged($event)"
	[dropdownEnabled]="false">
</app-kpi-widget>